"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.columnToCsv = exports.columnToText = exports.columnToMjml = void 0;

var _base = require("./common/base");

var _formatDefinition = require("./common/formatDefinition");

var columnToMjml = function columnToMjml(item, blockRenderer, isTopLevelNode) {
  var items = '';
  (item.children || []).forEach(function (x) {
    items += blockRenderer(x, blockRenderer, false);
  });
  item.properties.children = items;
  return (0, _base.toMjml)('mj-column', item.properties, _formatDefinition.EDIE_PROPS[_formatDefinition.EDIE_BLOCK_TYPE.COLUMN]);
};

exports.columnToMjml = columnToMjml;

var columnToText = function columnToText(item, childrenRenderer, isTopLevelNode) {
  var result = '';
  (item.children || []).forEach(function (x) {
    result += childrenRenderer(x, childrenRenderer);
  });
  return result + '\r\n';
};

exports.columnToText = columnToText;

var columnToCsv = function columnToCsv(item, childrenRenderer, isTopLevelNode, templateMetadata) {
  var content = templateMetadata.showHeaders ? item.properties.metadata.header : item.properties.metadata.text;
  return '"' + content + '"';
};

exports.columnToCsv = columnToCsv;